import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base-service';
import { CommonService } from './common.service';
import { environment } from 'src/environments/environment';
import * as Enums from './constants';

@Injectable()
export class InterceptorProvider extends BaseService implements HttpInterceptor {
  fileName: string = 'Interceptor-provider.interceptor.ts';

  constructor(private _commonService: CommonService) {
    super();
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    try {
      if (req.url !== Enums.CONSTANTS.GLOBAL_INIT_URL) {
        if (req.url !== this.getLocalloginURL()) {
          req = req.clone({
            setHeaders: {
              'userId': (this.getLocalUserId() != null) ? this.getLocalUserId() : "",
              'Authorization': (this.getLocalAuthToken() != null) ? this.getLocalAuthToken() : ""
            }
          });
        }
      }


      return next.handle(req);
    }
    catch (error) {
      let obj = {
        fileName: this.fileName,
        functionName: 'logout()',
        error: error
      }
      this._commonService.systemException(obj);
    }
  }
}